import flexeApi from '../lib/flexeApi';

export class ScopeDocumentsService {
  public async retrieveScopeDocuments(reservationScopeId: number): Promise<any> {
    return flexeApi
      .getScope(reservationScopeId)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          const msg = {
            responseUrl: response.url,
            responseCode: response.status,
            responseErr: response.text(),
          };
          return { error: response.status };
        }
      })
      .then((response: any) => {
        if (response !== undefined && !response.error) {
          const documents = response.data.documents.map((d) => {
            let shipper = null;
            let warehouse = null;
            if (d.visible_to === 'NONE') {
              shipper = false;
              warehouse = false;
            } else if (d.visible_to === 'SHIPPER') {
              shipper = true;
              warehouse = false;
            } else if (d.visible_to === 'WAREHOUSE') {
              shipper = false;
              warehouse = true;
            } else if (d.visible_to === 'ALL') {
              shipper = true;
              warehouse = true;
            } else {
              throw new Error('Invalid response from server ' + d.visible_to);
            }
            return {
              fileKey: d.file_key,
              fileName: d.file_name,
              kind: d.kind,
              visibleToShipper: shipper,
              visibleToWarehouse: warehouse,
            };
          });
          return documents;
        } else {
          return null;
        }
      });
  }
}
